import { call, put, takeLatest } from "redux-saga/effects";
import axios from "axios";
import {
  createDepositRequest,
  createDepositSuccess,
  createDepositFailure,
  getDepositRequest,
  getDepositSuccess,
  getDepositFailure,
  deleteDepositRequest,
  deleteDepositSuccess,
  deleteDepositFailure,
  updateDepositStatusRequest,
  updateDepositStatusSuccess,
  updateDepositStatusFailure,
  getSubscribedListRequest,
  getSubscribedListSuccess,
  getSubscribedListFailure,
  transferBenefitsRequest,
  transferBenefitsSuccess,
  transferBenefitsFailure,
} from "./bullionDepositSlice";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

// CREATE
function createDepositAPI(payload) {
  return axios.post(
    `${process.env.REACT_APP_API_BASE_URL}/api/v1/bullion-deposit/create-deposite-plan`,
    payload
  );
}

function* handleCreateDeposit(action) {
  try {
    const response = yield call(createDepositAPI, action.payload);
    yield put(createDepositSuccess(response.data));
    yield put(getDepositRequest());
    toast.success("Deposit plan created successfully");
  } catch (error) {
    const message = error.response?.data?.message || "Something went wrong";
    yield put(createDepositFailure(message));
    toast.error(`Failed to create deposit plan: ${message}`);
  }
}

// GET
function getDepositAPI(params) {
  const { page = 1, limit = 10, search = "" } = params;
  return axios.get(
    `${process.env.REACT_APP_API_BASE_URL}/api/v1/bullion-deposit/getbulliondeposit`,
    {
      params: { page, limit, search },
    }
  );
}

function* handleGetDeposit(action) {
  try {
    const response = yield call(getDepositAPI, action.payload || {});
    const data = response.data?.data || {};
    const planList = data.depositplanlist || [];
    const total = data.total || 0;

    yield put(getDepositSuccess({ plans: planList, total }));
  } catch (error) {
    const message = error.response?.data?.message || "Failed to fetch plans";
    yield put(getDepositFailure(message));
    toast.error(message);
  }
}

// DELETE
function deleteDepositAPI(planId) {
  return axios.delete(
    `${process.env.REACT_APP_API_BASE_URL}/api/v1/bullion-deposit/deletedepositeplan/${planId}`
  );
}

function* handleDeleteDeposit(action) {
  try {
    yield call(deleteDepositAPI, action.payload);
    yield put(deleteDepositSuccess(action.payload));
    yield put(getDepositRequest());
  } catch (error) {
    const message = error.response?.data?.message || "Delete failed";
    yield put(deleteDepositFailure(message));
    toast.error(`Failed to delete deposit plan: ${message}`);
  }
}

// UPDATE STATUS
function updateDepositStatusAPI(id) {
  return axios.patch(
    `${process.env.REACT_APP_API_BASE_URL}/api/v1/bullion-deposit/updatedepositeplanstatus?id=${id}`
  );
}

function* handleUpdateDepositStatus(action) {
  try {
    yield call(updateDepositStatusAPI, action.payload);
    yield put(updateDepositStatusSuccess());
    yield put(getDepositRequest());
    toast.success("Plan status updated successfully");
  } catch (error) {
    const message = error.response?.data?.message || "Failed to update status";
    yield put(updateDepositStatusFailure(message));
    toast.error(`Failed to update plan status: ${message}`);
  }
}

// GET SUBSCRIBED LIST
function getSubscribedListAPI(payload) {
  return axios.get(
    `${process.env.REACT_APP_API_BASE_URL}/api/v1/bullion-deposit/getsubscribedplanlistdashboard`,
    { params: payload }
  );
}

function* handleGetSubscribedList(action) {
  try {
    const response = yield call(getSubscribedListAPI, action.payload);
    const data = response.data?.data;

    yield put(
      getSubscribedListSuccess({
        list: data.subscriberlist || [],
        total: data.total || 0,
      })
    );

    toast.success("Subscriber list fetched successfully");
  } catch (error) {
    const message =
      error.response?.data?.message || "Failed to fetch subscriber list";
    yield put(getSubscribedListFailure(message));
    toast.error(message);
  }
}

function transferBenefitsAPI(payload) {
  return axios.post(
    `${process.env.REACT_APP_API_BASE_URL}/api/v1/bullion-deposit/transferbenefitstocustomers`,
    payload
  );
}

function* handleTransferBenefits(action) {
  try {
    yield call(transferBenefitsAPI, action.payload);
    yield put(transferBenefitsSuccess());
    yield put(getSubscribedListRequest());
    toast.success("Benefits transferred successfully");
  } catch (error) {
    const message = error.response?.data?.message || "Transfer failed";
    yield put(transferBenefitsFailure(message));
    toast.error(message);
  }
}

export function* bullionDepositSaga() {
  yield takeLatest(createDepositRequest.type, handleCreateDeposit);
  yield takeLatest(getDepositRequest.type, handleGetDeposit);
  yield takeLatest(deleteDepositRequest.type, handleDeleteDeposit);
  yield takeLatest(updateDepositStatusRequest.type, handleUpdateDepositStatus);
  yield takeLatest(getSubscribedListRequest.type, handleGetSubscribedList);
  yield takeLatest(transferBenefitsRequest.type, handleTransferBenefits);
}
